/**
 * Cart Dependencies Manager
 * When a stone (lab grown diamond) is removed, also remove the paired ring
 *
 * Since pair IDs may not be set by external apps, we pair items by:
 * 1. Looking for adjacent items in the cart (ring + stone added together)
 * 2. Matching made-to-order rings with lab-grown diamonds
 */

(function() {
  let isProcessing = false;

  function isStoneProduct(item) {
    const type = (item.dataset.productType || '').toLowerCase();
    const tags = (item.dataset.productTags || '').toLowerCase();
    return type.includes('diamond') || type.includes('stone') ||
           tags.includes('diamond') || tags.includes('lab-grown');
  }

  function isRingProduct(item) {
    const type = (item.dataset.productType || '').toLowerCase();
    const tags = (item.dataset.productTags || '').toLowerCase();
    // Ring is anything that's NOT a stone and has madetoorder tag or is a ring type
    return !isStoneProduct(item) &&
           (tags.includes('madetoorder') || type.includes('ring'));
  }

  document.addEventListener('click', async function(event) {
    const removeButton = event.target.closest('cart-remove-button');
    if (!removeButton || isProcessing) return;

    const lineIndex = removeButton.dataset.index;
    const cartItem = document.querySelector(`#CartItem-${lineIndex}`);
    if (!cartItem) return;

    // Only cascade if removing a stone
    if (!isStoneProduct(cartItem)) return;

    // Get all cart items
    const allItems = Array.from(document.querySelectorAll('.cart-item'));
    const stoneIdx = parseInt(lineIndex);

    // Strategy 1: Check for pair ID match
    const pairId = cartItem.dataset.pairId;
    if (pairId && pairId !== 'undefined' && pairId !== 'null' && pairId !== '') {
      const pairedItem = allItems.find(item =>
        item.dataset.pairId === pairId &&
        item.dataset.lineIndex !== lineIndex
      );
      if (pairedItem) {
        await removeItems([stoneIdx, parseInt(pairedItem.dataset.lineIndex)], event);
        return;
      }
    }

    // Strategy 2: Find adjacent ring (stone and ring added together are usually adjacent)
    const adjacentItem = allItems.find(item => {
      const itemIdx = parseInt(item.dataset.lineIndex);
      return isRingProduct(item) && Math.abs(itemIdx - stoneIdx) === 1;
    });

    if (adjacentItem) {
      await removeItems([stoneIdx, parseInt(adjacentItem.dataset.lineIndex)], event);
      return;
    }

    // Strategy 3: If only one ring in cart, pair with it
    const rings = allItems.filter(item => isRingProduct(item));
    if (rings.length === 1) {
      await removeItems([stoneIdx, parseInt(rings[0].dataset.lineIndex)], event);
      return;
    }

    // No match found - let normal removal proceed
  }, true);

  async function removeItems(indexes, event) {
    event.preventDefault();
    event.stopPropagation();
    isProcessing = true;

    try {
      // Sort descending to avoid index shifting
      indexes.sort((a, b) => b - a);

      for (const idx of indexes) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: idx, quantity: 0 })
        });
      }
      location.reload();
    } catch (e) {
      console.error('Error removing items:', e);
      location.reload();
    } finally {
      isProcessing = false;
    }
  }
})();
